"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const GenPublicLinkModalWrapper_1 = __importDefault(require("../components/GenPublicLinkModalWrapper"));
const withPublicLinkModal = (WrappedComponent) => {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const ComponentWithPublicLink = (props) => {
        return (react_1.default.createElement(GenPublicLinkModalWrapper_1.default, { roundId: props === null || props === void 0 ? void 0 : props.roundId }, ({ handleOpenPublicLinkModal }) => (react_1.default.createElement(WrappedComponent, { ...props, openPublicLinkModal: handleOpenPublicLinkModal }))));
    };
    ComponentWithPublicLink.displayName = `withPublicLinkModal(${displayName})`;
    return ComponentWithPublicLink;
};
exports.default = withPublicLinkModal;
